import * as React from 'react';

function SvgPencilEdit(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.73 6.305a3 3 0 010 4.243l-.971.971.005.005-.99.99-.005-.005L12.757 22.52l.005.005-.99.99-.005-.005-.355.355-3.835.07a1 1 0 01-1.018-1.019l.07-3.835L19.947 5.764a3 3 0 014.242 0l.541.541zM11.767 21.531L21.78 11.519l-2.803-2.803L8.964 18.727l2.803 2.804zm-3.75-1.77l2.717 2.717-2.767.05.05-2.768zm14.752-9.232l-2.803-2.803.97-.972a1.6 1.6 0 012.264 0l.54.541a1.6 1.6 0 010 2.263l-.971.971z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgPencilEdit;
